"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    dropdown: {
      borderWidth: 1,
      borderStyle: 'solid',
      color: theme.palette.NEUTRAL600,
      borderColor: theme.palette.NEUTRAL500,
      backgroundColor: theme.palette.NEUTRAL000,
      textTransform: 'none',
      padding: theme.spacing(0.625, 2),
      '&.selected': {
        borderColor: theme.palette.BLUE400,
        color: theme.palette.BLUE400,
        '&:focus': {
          boxShadow: '0 2px 2px -1px rgba(54, 97, 126, 0.3), 0px 0px 0px 3px rgba(1, 114, 203, 0.5)'
        }
      },
      '&.fullWidth': {
        justifyContent: 'space-between',
        width: '100%'
      },
      '&.withIcon': {
        justifyContent: 'start'
      },
      '&:focus': {
        boxShadow: '0 2px 2px -1px rgba(54, 97, 126, 0.3), 0px 0px 0px 3px rgba(95, 115, 140, 0.3)'
      },
      '&[disabled]': {
        borderColor: theme.palette.NEUTRAL090,
        color: theme.palette.NEUTRAL090
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;